<div
  class="container"
  *ngIf="{
    isPasswordChangeActive: isPasswordChangeActive$ | async,
    isEmailChangeActive: isEmailChangeActive$ | async
  } as data"
>
  <div class="profile-section" *ngIf="!data.isPasswordChangeActive">
    <div class="profile-info">
      <h3>{{ 'label.Password' | translate }}</h3>
      <p>
        {{ 'text.PasswordRequirementsText' | translate }}
      </p>
    </div>

    <div class="profile-action">
      <button
        [ngClass]="{ 'change-password-disabled': data.isEmailChangeActive }"
        class="change-password"
        (click)="onChangePassword()"
      >
        {{ 'label.ChangePassword' | translate }}
      </button>
    </div>
  </div>

  <div
    [formGroup]="editForm"
    #ngForm="ngForm"
    *ngIf="data.isPasswordChangeActive"
  >
    <div class="form-container-wrapper">
    <div class="profile-info left-side">
      <h3>{{ 'label.Password' | translate }}</h3>
      <p>
        {{ 'text.PasswordRequirementsText' | translate }}
      </p>
    </div>
      <div class="form-container">
        <div class="form-item current-pass">
          <div class="password-label">
            <span>{{ 'label.CurrentPassword' | translate }}</span>
          </div>
          <div class="password-container">
            <hrra-password-input
              formControlName="currentPass"
              [withPlaceholder]="false"
            >
            </hrra-password-input>
          </div>
          <div class="error-message">
            <mat-error
              *ngIf="
                editForm.controls['currentPass'].hasError('required') &&
                (editForm.controls['currentPass'].touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
            <mat-error
              *ngIf="isCurrentPasswordIncorrect$ | async"
              class="validation-message"
              >{{
                'message.CurrentPasswordYouEnteredIsIncorrect' | translate
              }}</mat-error
            >
          </div>
        </div>

        <div class="form-item new-pass">
          <div class="password-label">
            <span>{{ 'label.NewPassword' | translate }}</span>
          </div>
          <div class="password-container">
            <hrra-password-input
              formControlName="newPass"
              [withPlaceholder]="false"
            >
            </hrra-password-input>
          </div>
          <div class="error-messages">
            <mat-error
              *ngIf="
                editForm.controls['newPass'].errors?.pattern &&
                (editForm.controls['newPass'].touched || ngForm.submitted) &&
                editForm.controls['newPass'].value?.length >= passwordMinLength
              "
              class="password-validation-error validation-message"
            >
              {{ 'message.PasswordRequirementMessage' | translate }}
              <span [matTooltip]="'text.PasswordRequirementsText' | translate">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </mat-error>
            <mat-error
              *ngIf="
                editForm.controls['newPass'].hasError('required') &&
                (editForm.controls['newPass'].touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
            <mat-error
              *ngIf="
                editForm.controls['newPass'].hasError('minlength') &&
                (editForm.controls['newPass'].touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.PasswordTooShort' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="form-item repeat-pass">
          <div class="password-label">
            <span>{{ 'label.RepeatPassword' | translate }}</span>
          </div>
          <div class="password-container">
            <hrra-password-input
              formControlName="repeatPass"
              [withPlaceholder]="false"
            >
            </hrra-password-input>
          </div>
          <div class="error-messages">
            <mat-error
              *ngIf="
                editForm.controls['repeatPass'].hasError('required') &&
                (editForm.controls['repeatPass'].touched || ngForm.submitted)
              "
              class="validation-message"
              >{{ 'message.MandatoryField' | translate }}</mat-error
            >
            <mat-error
              *ngIf="
                (editForm.hasError('PasswordMismatch') &&
                  (editForm.controls['repeatPass'].touched ||
                    ngForm.submitted)) ||
                (jobseekerPasswordMismatch$ | async)
              "
              class="validation-message"
              >{{ 'message.PasswordMismatch' | translate }}</mat-error
            >
          </div>
        </div>

        <div class="buttons">
          <app-button
            (click)="onSave()"
            [text]="'label.Save' | translate"
            [type]="buttonType.coloured"
            [typeAttribute]="buttonAttributeType.submit"
            class="buttons__save"
          ></app-button>
          <app-button
            (click)="onCancel()"
            [text]="'label.Cancel' | translate"
            [type]="buttonType.uncoloured"
            [typeAttribute]="buttonAttributeType.button"
            class="buttons__cancel"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
